export const newsSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': 'https://www.datauniverse.co.kr/#website',
      url: 'https://www.datauniverse.co.kr',
      name: '㈜데이터유니버스',
    },
    {
      '@type': 'Organization',
      '@id': 'https://www.datauniverse.co.kr/#organization',
      name: '㈜데이터유니버스',
      url: 'https://www.datauniverse.co.kr',
      logo: {
        '@type': 'ImageObject',
        url: 'https://img.datau.co.kr/dulogo.png',
      },
      sameAs: [
        'https://www.youtube.com/@%EB%8D%B0%EC%9D%B4%ED%84%B0%EC%9C%A0%EB%8B%88%EB%B2%84%EC%8A%A4',
      ],
    },
    {
      '@type': 'WebPage',
      '@id': 'https://www.datauniverse.co.kr/news/#webpage',
      url: 'https://www.datauniverse.co.kr/news',
      name: '뉴스룸 | ㈜데이터유니버스',
      description: '㈜데이터유니버스의 최신 보도자료 및 소식을 확인해보세요.',
    },
  ],
}
